// Example:
// const source = [
//     {id: 2, label: "Two"},
//     {id: 3, label: "Three"},
//     {id: 1, label: "One"},
// ]
// const order = [1, 2, 3]

// Props: (source, order, "id")
export function mapOrder<T>(list: T[] = [], order: string[] | undefined, key: keyof T): T[] {
  const copy = [...list] // clone, do not sort in place
  if (!order?.length) return copy

  const rank = new Map(order.map((id, i) => [id, i]))
  return copy.sort((a, b) => {
    const ra = rank.get(String(a[key])) ?? Number.POSITIVE_INFINITY
    const rb = rank.get(String(b[key])) ?? Number.POSITIVE_INFINITY
    return ra - rb
  })
}
